/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientCreateDto = {
  /**
   * Client phone number including country code.
   */
  phoneNumber: string;
  /**
   * Client locale code
   */
  locale?: ClientCreateDto.locale;
};
export namespace ClientCreateDto {
  /**
   * Client locale code
   */
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

